// Components
import { TaxonomyProvider } from "./contexts/TaxonomyContext";
import { AllRoutes } from "./routes/index.jsx";

export const App = () => {
  return (
    <TaxonomyProvider>
      <AllRoutes />
    </TaxonomyProvider>
  );
};
